import { Stack } from "@chakra-ui/react";

function RoundBackground({ children, sm, ...props }) {
  return (
    <Stack borderRadius={"50%"} bg="#FAFAFA" p={sm ? "2px" : "10px"} {...props}>
      {children}
    </Stack>
  );
}

export default RoundBackground;
